import React, { useContext } from "react";
import GrayBtn from "../button/GrayBtn";
import ExploreStyle from "./ExploreBtn.module.css";
import WhiteBtn from "../button/WhiteBtn";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../store";

function SingleChoiceBtnGroup(props) {
  const { ExploreStore } = useContext(RootStoreContext);
  const { role, updateData } = ExploreStore;
  const list = Object.values(props);

  return (
    <div className="App">
      <>
        {list.map((text, index) =>
          text === role ? (
            <GrayBtn
              variant="h5"
              key={`text-${index}`}
              onClick={() => {
                updateData("role", text);
              }}
              className={ExploreStyle.ExploreGrayBtn}
            >
              {text}
            </GrayBtn>
          ) : (
            <WhiteBtn
              variant="h5"
              key={`text-${index}`}
              onClick={() => {
                updateData("role", text);
              }}
              className={ExploreStyle.ExploreWhiteBtn}
            >
              {text}
            </WhiteBtn>
          )
        )}
      </>
    </div>
  );
}

export default observer(SingleChoiceBtnGroup);
